import { Component, Inject, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { SaveService } from '../../../../services/save.service';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { MatDialog } from "@angular/material/dialog";
import { Utils } from '../../../../utils/utils';
import { ControllerConfigFormComponent } from './controllerconfig-form.component';

@Component({
    selector: 'controllerconfig-menu',
    templateUrl: './controllerconfig-menu.component.html',
    styleUrls: ['../../../../style/menu.component.less'],
    standalone: false
})

export class ControllerConfigMenuComponent {

    @Input('descriptions') descriptions: ControllerConfigDescription[] = [];
    @Input('datatypes') datatypes: ControllerConfigDataType[] = [];
    @Output() onRefresh = new EventEmitter<{}>();

    languageList: Language[] | undefined = [];

    constructor(private activatedRoute: ActivatedRoute,
        private router: Router
        , private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public saveService: SaveService
        , public defaults: DefaultValuesService
        , private dialogForm: MatDialog

    ) {
    }

    onSave() {
        this.saveService.fireSaveAll();
    }

    openNewConfigurationPopup() {
        const dialog = this.dialogForm.open(ControllerConfigFormComponent, {
            panelClass: ['custom-mat-dialog'],
            disableClose: true,
            data: { "descriptions": this.descriptions, "datatypes": this.datatypes }
        })
        dialog.afterClosed().subscribe(() => {
            this.onRefresh.emit({})
        })
    }
}
